import { Autocomplete, TextField } from '@mui/material';
import styled from 'styled-components';
import { COLORS } from 'theme/colors';

export type InputPaddingType = 'dense' | 'normal';

export const StyledTextField = styled(TextField)<{
  padding?: InputPaddingType;
  width?: number;
}>`
  && .Mui-disabled {
    &.MuiInputLabel-root {
      color: rgba(0, 0, 0, 0.6);
    }

    &.MuiInputBase-root {
      background-color: #f7f7f7;
      color: black;
    }
  }

  && .Mui-error {
    & fieldset {
      border-color: ${COLORS.DARK_RED};
    }
  }

  && {
    width: ${(props) => (props.width ? `${props.width}px` : '300px')};
    ${({ padding }) =>
      padding === 'dense' &&
      `
    && input {
      padding: 4px 8px;
    }
    
    && label {
      top: -4px
    }`}
  }
`;

export const StyledAutocomplete = styled(Autocomplete)<{
  padding?: InputPaddingType;
}>`
  && {
    ${({ padding }) =>
      padding === 'dense' &&
      `
    &&& input {
      padding: 0px 2px;
    }

    .MuiInputBase-root {
      padding: 4px 8px;
    }
    
  `}
  }
`;

export const AutocompleteTextField = styled(StyledTextField)`
  && {
    .MuiAutocomplete-input {
      min-width: 70%;
    }
  }
`;
